import React from 'react';
import { Eye, EyeOff, LogIn } from 'lucide-react';
import FormField from '../../HrDashboard/utils/InputField';

const LoginForm = ({
  email,
  setEmail,
  password,
  setPassword,
  showPassword,
  setShowPassword,
  onSubmit,
  isLoading,
  error,
}) => {

  // 🔹 Field Configurations (Main Frame Structure)
  const emailField = {
    label: "Email Address",
    name: "email",
    type: "email",
    placeholder: "Enter your email",
  };

  const passwordField = {
    label: "Password",
    name: "password",
    type: showPassword ? "text" : "password",
    placeholder: "Enter your password",
  };

  return (
    <form onSubmit={onSubmit} className="space-y-5">
      <FormField
        field={emailField}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        isEditable={true}
      />
      <div className="relative">
        <FormField
          field={passwordField}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          isEditable={true}
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-3 top-[42px] text-gray-500 hover:text-gray-700 transition-colors"
        >
          {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
        </button>
      </div>
      {error && (
        <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-red-600 text-sm font-medium">
            {error}
          </p>
        </div>
      )}
      <div className="flex items-center justify-between text-sm">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            className="w-4 h-4 rounded accent-blue-500"
          />
          <span className="text-gray-600">
            Remember me
          </span>
        </label>

        <a
          href="#"
          className="text-blue-600 hover:text-blue-700 font-medium transition-colors"
        >
          Forgot password?
        </a>
      </div>
      <button
        type="submit"
        disabled={isLoading}
        className="w-full py-3 rounded-lg font-semibold text-white transition-all duration-300 flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
        style={{
          backgroundColor: '#0095fa',
          boxShadow: '0 5px 15px rgba(0, 149, 250, 0.4)',
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#0f6caa';
          e.target.style.boxShadow = '0px 0px 20px rgba(0, 149, 250, 0.8)';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = '#0095fa';
          e.target.style.boxShadow = '0 5px 15px rgba(0, 149, 250, 0.4)';
        }}
      >
        {isLoading ? (
          <>
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
            Logging in...
          </>
        ) : (
          <>
            <LogIn size={18} />
            Login
          </>
        )}
      </button>

      {/* Sign Up */}
      <p className="text-center text-gray-600 text-sm">
        Don't have an account?{' '}
        <a
          href="/sign-up"
          className="text-blue-600 hover:text-blue-700 font-semibold transition-colors"
        >
          Sign up here
        </a>
      </p>

    </form>
  );
};

export default LoginForm;